const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

export const getAllTag = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/space/tags`, {
        method: 'GET',
    });

    return response; // Return the list of tags

  } catch (error) {
    console.error('Error fetching tags:', error);
    throw error; // Rethrow the error for handling in the calling code
  }
};